import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import Layout from './components/layout/Layout';
import AdminLayout from './components/admin/AdminLayout';
import Home from './pages/Home';
import LeGroupe from './pages/LeGroupe';
import Implantations from './pages/Implantations';
import Flotte from './pages/Flotte';
import Services from './pages/Services';
import TransportsSpecialises from './pages/TransportsSpecialises';
import Devis from './pages/Devis';
import EstimationTaxi from './pages/EstimationTaxi';
import EstimationTransport from './pages/EstimationTransport';
import Avis from './pages/Avis';
import Recrutement from './pages/Recrutement';
import Contact from './pages/Contact';
import Ambulance03Avermes from './pages/Ambulance03Avermes';
import AmbulanceTrongetLeMontet from './pages/AmbulanceTrongetLeMontet';
import CelineAmbulanceDiou from './pages/CelineAmbulanceDiou';
import AmbulanceBeaulonGarnat from './pages/AmbulanceBeaulonGarnat';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminDevis from './pages/admin/AdminDevis';
import AdminContacts from './pages/admin/AdminContacts';
import AdminApplications from './pages/admin/AdminApplications';
import AdminReviews from './pages/admin/AdminReviews';
import AdminGallery from './pages/admin/AdminGallery';
import AdminProfile from './pages/admin/AdminProfile';
import AdminChat from './pages/admin/AdminChat';
import ProtectedRoute from './components/admin/ProtectedRoute';
import './App.css';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="le-groupe" element={<LeGroupe />} />
            <Route path="implantations" element={<Implantations />} />
            <Route path="flotte" element={<Flotte />} />
            <Route path="services" element={<Services />} />
            <Route path="transports-specialises" element={<TransportsSpecialises />} />
            <Route path="devis" element={<Devis />} />
            <Route path="estimation-taxi" element={<EstimationTaxi />} />
            <Route path="estimation-transport" element={<EstimationTransport />} />
            <Route path="avis" element={<Avis />} />
            <Route path="recrutement" element={<Recrutement />} />
            <Route path="contact" element={<Contact />} />
            <Route path="ambulance-03-avermes" element={<Ambulance03Avermes />} />
            <Route path="ambulance-tronget-le-montet" element={<AmbulanceTrongetLeMontet />} />
            <Route path="celine-ambulance-diou" element={<CelineAmbulanceDiou />} />
            <Route path="ambulance-beaulon-garnat" element={<AmbulanceBeaulonGarnat />} />
          </Route>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
            <Route index element={<AdminDashboard />} />
            <Route path="devis" element={<AdminDevis />} />
            <Route path="contacts" element={<AdminContacts />} />
            <Route path="candidatures" element={<AdminApplications />} />
            <Route path="avis" element={<AdminReviews />} />
            <Route path="galerie" element={<AdminGallery />} />
            <Route path="chat" element={<AdminChat />} />
            <Route path="profil" element={<AdminProfile />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
